export const sort = (item, key) => key ? item.sort((a, b) => a[key] > b[key] ? 1 : -1) : item.sort((a, b) => a > b ? 1 : -1);


// WEBPACK FOOTER //
// ./src/components/Maintenance/helper.js